import store from '../../store'

export default (to, from, next) => {
  // If the path is for logged user
  if (to.matched.some(m => 'logged' in m.meta && m.meta.logged)) {
    // If user is NOT logged in, go to login
    if (!store.state.auth.logged) {
      return next({name: 'Login'})
    } else {
      // Otherwise, go to the next path
      return next()
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/middleware/logged.js